import React, {Component} from 'react';

import _ from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import validator from '../../helpers/validator';

import classes from './ConversionForm.module.css';

class ConversionCondition extends Component {
    state = {
        formIsValid:  false,
        formControls: {
            condition: {
                value:           '',
                placeholder:     'Condition',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            result: {
                value:           '',
                placeholder:     'Result',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            }
        }
    }

    componentDidMount() {
        const {element} = this.props;

        if (!_.isEmpty(element)) {
            const updatedControls = {...this.state.formControls};

            updatedControls.condition.value = element.condition;
            updatedControls.condition.touched = true;
            updatedControls.condition.valid = true;

            updatedControls.result.value = element.result;
            updatedControls.result.touched = true;
            updatedControls.result.valid = true;

            this.setState({
                formControls: updatedControls
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {element} = this.props;

        if (prevProps.rawDataType !== this.props.rawDataType && _.isEmpty(element)) {
            const updatedControls = {...this.state.formControls};

            updatedControls.condition.value = '';
            updatedControls.condition.touched = false;
            updatedControls.condition.valid = false;

            updatedControls.result.value = '';
            updatedControls.result.touched = false;
            updatedControls.result.valid = false;

            this.setState({
                formControls: updatedControls
            });
        }

        if (prevProps.element !== element) {
            const updatedControls = {...this.state.formControls};

            updatedControls.condition.value = element.condition;
            updatedControls.condition.touched = true;
            updatedControls.condition.valid = true;

            updatedControls.result.value = element.result;
            updatedControls.result.touched = true;
            updatedControls.result.valid = true;

            this.setState({
                formControls: updatedControls
            });
        }
    }

    handleValidation = event => {
        const {index, onModelChange} = this.props;

        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });

        onModelChange(this.state.formControls, index);
    }

    handleChange = event => {
        const { value, name } = event.target;
        const updatedControls = {...this.state.formControls};

        updatedControls[name].value = value;

        this.setState({
            formControls: updatedControls
        });
    }

    preventCharacters = event => {
        const invalidCharacters = ['.', '-', '+', 'e'];

        if (invalidCharacters.indexOf(event.key) > -1) {
            event.preventDefault();
        }
    }

    renderCondition = type => {
        const {isKey2ActConversion} = this.props;

        switch (type) {
            case 'boolean':
                return (
                    <React.Fragment>
                        <Select
                            value={this.state.formControls.condition.value}
                            onChange={this.handleChange}
                            className={classes.select}
                            disabled={isKey2ActConversion}
                            inputProps={{
                                name:   'condition',
                                id:     'condition',
                                onBlur: this.handleValidation
                            }}
                        >
                            <MenuItem
                                value={true}
                            >
                                True
                            </MenuItem>
                            <MenuItem
                                value={false}
                            >
                                False
                            </MenuItem>
                        </Select>
                        {!this.state.formControls.condition.valid &&
                         this.state.formControls.condition.touched && <FormHelperText className={classes.error}>{this.state.formControls.condition.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'integer':
                return (
                    <React.Fragment>
                        <Input
                            id="condition"
                            name="condition"
                            type="number"
                            disabled={isKey2ActConversion}
                            inputProps={{
                                min:       0,
                                onKeyDown: event => { this.preventCharacters(event); },
                                onBlur:    this.handleValidation
                            }}
                            value={this.state.formControls.condition.value}
                            onChange={this.handleChange}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.condition.valid &&
                         this.state.formControls.condition.touched && <FormHelperText className={classes.error}>{this.state.formControls.condition.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'float':
                return (
                    <React.Fragment>
                        <Input
                            id="condition"
                            name="condition"
                            type="number"
                            disabled={isKey2ActConversion}
                            inputProps={{
                                min:    0,
                                onBlur: this.handleValidation
                            }}
                            value={this.state.formControls.condition.value}
                            onChange={this.handleChange}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.condition.valid &&
                         this.state.formControls.condition.touched && <FormHelperText className={classes.error}>{this.state.formControls.condition.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'text':
                return (
                    <React.Fragment>
                        <Input
                            id="condition"
                            name="condition"
                            disabled={isKey2ActConversion}
                            value={this.state.formControls.condition.value}
                            onChange={this.handleChange}
                            inputProps={{
                                onBlur: this.handleValidation
                            }}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.condition.valid &&
                         this.state.formControls.condition.touched && <FormHelperText className={classes.error}>{this.state.formControls.condition.message}</FormHelperText>}
                    </React.Fragment>
                );
            default:
                break;
        }
    }

    renderResult = type => {
        const {isKey2ActConversion} = this.props;

        switch (type) {
            case 'boolean':
                return (
                    <React.Fragment>
                        <Select
                            value={this.state.formControls.result.value}
                            onChange={this.handleChange}
                            className={classes.select}
                            disabled={isKey2ActConversion}
                            inputProps={{
                                name:   'result',
                                id:     'result',
                                onBlur: this.handleValidation
                            }}
                        >
                            <MenuItem
                                value={true}
                            >
                                True
                            </MenuItem>
                            <MenuItem
                                value={false}
                            >
                                False
                            </MenuItem>
                        </Select>
                        {!this.state.formControls.result.valid &&
                         this.state.formControls.result.touched && <FormHelperText className={classes.error}>{this.state.formControls.result.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'integer':
                return (
                    <React.Fragment>
                        <Input
                            id="result"
                            name="result"
                            type="number"
                            disabled={isKey2ActConversion}
                            inputProps={{
                                min:       0,
                                onKeyDown: event => { this.preventCharacters(event); },
                                onBlur:    this.handleValidation
                            }}
                            value={this.state.formControls.result.value}
                            onChange={this.handleChange}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.result.valid &&
                         this.state.formControls.result.touched && <FormHelperText className={classes.error}>{this.state.formControls.result.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'text':
                return (
                    <React.Fragment>
                        <Input
                            id="result"
                            name="result"
                            inputProps={{
                                onBlur: this.handleValidation
                            }}
                            value={this.state.formControls.result.value}
                            onChange={this.handleChange}
                            disabled={isKey2ActConversion}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.result.valid &&
                         this.state.formControls.result.touched && <FormHelperText className={classes.error}>{this.state.formControls.result.message}</FormHelperText>}
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        <Input
                            id="result"
                            name="result"
                            value={this.state.formControls.result.value}
                            disabled
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                    </React.Fragment>
                );
        }
    }

    render() {
        const {rawDataType, displayDataType} = this.props;

        return (
            <div className={classes.halfWidthInputContainer}>
                <FormControl className={classes.halfWidthInputWrapper}>
                    <InputLabel
                        htmlFor="condition"
                        classes={{
                            root:    classes.label,
                            focused: classes.labelFocused
                        }}
                    >
                        {this.state.formControls.condition.placeholder}
                    </InputLabel>
                    {this.renderCondition(rawDataType)}
                </FormControl>
                <FormControl className={classes.halfWidthInputWrapper}>
                    <InputLabel
                        htmlFor="result"
                        classes={{
                            root:    classes.label,
                            focused: classes.labelFocused
                        }}
                    >
                        {this.state.formControls.result.placeholder}
                    </InputLabel>
                    {this.renderResult(displayDataType)}
                </FormControl>
            </div>
        );
    }
}

export default ConversionCondition;
